import React, { useState } from "react";
import "./RememberingBobBelfi.css";

const bobPartyImages = [
  "Remembering Bob Belfi web 60.jpg",
  "Remembering Bob Belfi web 61.jpg",
  "Remembering Bob Belfi web 62.jpg",
  "Remembering Bob Belfi web 64.jpg",
  "Remembering Bob Belfi web 65.jpg",
  "Remembering Bob Belfi web 66.jpg",
  "Remembering Bob Belfi web 68.jpg",
  "Remembering Bob Belfi web 69.jpg",
  "Remembering Bob Belfi web 70.jpg",
  "Remembering Bob Belfi web 71.jpg",
  "Remembering Bob Belfi web 72.jpg",
  "Remembering Bob Belfi web 73.jpg",
  "Remembering Bob Belfi web 74.jpg",
  "Remembering Bob Belfi web 75.jpg",
  "Remembering Bob Belfi web 76.jpg",
  "Remembering Bob Belfi web 77.jpg",
  "Remembering Bob Belfi web 78.jpg",
  "Remembering Bob Belfi web 79.jpg",
  "Remembering Bob Belfi web 80.jpg",
  "Remembering Bob Belfi web 81.jpg",
  "Remembering Bob Belfi web 82.jpg",
  "Remembering Bob Belfi web 83.jpg",
  "Remembering Bob Belfi web 84.jpg",
  "Remembering Bob Belfi web 85.jpg",
  "Remembering Bob Belfi web 86.jpg",
  "Remembering Bob Belfi web 87.jpg",
  "Remembering Bob Belfi web 88.jpg",
  "Remembering Bob Belfi web 89.jpg",
  "Remembering Bob Belfi web 90.jpg",
  "Remembering Bob Belfi web 91.jpg",
  "Remembering Bob Belfi web 92.jpg",
  "Remembering Bob Belfi web 93.jpg",
  "Remembering Bob Belfi web 94.jpg",
  "Remembering Bob Belfi web 95.jpg",
];

const miscBobImages = [
  "remembering bob belfi 26.jpg",
  "Remembering Bob Belfi web 1.jpg",
  "Remembering Bob Belfi web 2.jpg",
  "Remembering Bob Belfi web 3.jpg",
  "Remembering Bob Belfi web 4.jpg",
  "Remembering Bob Belfi web 5.jpg",
  "Remembering Bob Belfi web 6.jpg",
  "Remembering Bob Belfi web 7.jpg",
  "Remembering Bob Belfi web 8.jpg",
  "Remembering Bob Belfi web 9.jpg",
  "Remembering Bob Belfi web 10.jpg",
  "Remembering Bob Belfi web 11.jpg",
  "Remembering Bob Belfi web 12.jpg",
  "Remembering Bob Belfi web 13.jpg",
  "Remembering Bob Belfi web 15.jpg",
  "Remembering Bob Belfi web 16.jpg",
  "Remembering Bob Belfi web 17.jpg",
  "Remembering Bob Belfi web 18.jpg",
  "Remembering Bob Belfi web 19.jpg",
  "Remembering Bob Belfi web 20.jpg",
  "Remembering Bob Belfi web 21.jpg",
  "Remembering Bob Belfi web 22.jpg",
  "Remembering Bob Belfi web 23.jpg",
  "Remembering Bob Belfi web 24.jpg",
  "Remembering Bob Belfi web 25.jpg",
  "Remembering Bob Belfi web 29.jpg",
  "Remembering Bob Belfi web 30.jpg",
  "Remembering Bob Belfi web 31.jpg",
];

export default function RememberingBobBelfi() {
  // For a simple lightbox effect
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <div className="remembering-bob-outer">
      <div className="remembering-bob-container">
        <h1 className="remembering-title">Remembering Bob Belfi</h1>
        <div className="remembering-photo-section">
          <img
            src="/Assets/BobBelfi/Remembering Bob Belfi web 51.jpg"
            alt="Bob Belfi main"
            className="remembering-photo main-photo"
          />
        </div>
        <div className="remembering-message-section modern-message">
          <p className="remembering-message">
            It is with great sadness that we announce the passing of{" "}
            <span className="highlight">Bob Belfi</span>
            .
            <br />
            Bob was not only a talented technician and valued employee, but also
            a cherished friend to all of us at Rolling Thunder Cycles.
            <br />
            His dedication, kindness, and sense of humor touched everyone who
            knew him.
            <br />
            He will be deeply missed by his family, friends, coworkers, and
            customers.
          </p>
          <p>
            On <span className="highlight">February 16th, 2013</span> we had a
            dinner to remember our friend Bob Belfi, who lost his battle with
            cancer only a few weeks before.
            <br />
            Here are some photos of the party to celebrate his life.
          </p>
          <p>See if you can find your smile in these images.</p>
        </div>
        <h2 className="remembering-gallery-title">
          Celebration of Life Party Photos
        </h2>
        <div className="remembering-gallery-grid">
          {bobPartyImages.map((img, idx) => (
            <img
              key={img}
              src={`/Assets/BobBelfi/bobParty/${encodeURIComponent(img)}`}
              alt={`Bob Belfi party ${idx + 1}`}
              className="remembering-gallery-img"
              onClick={() =>
                setSelectedImg(
                  `/Assets/BobBelfi/bobParty/${encodeURIComponent(img)}`,
                )
              }
              tabIndex={0}
              role="button"
              aria-label={`Enlarge image ${idx + 1}`}
            />
          ))}
        </div>
        <h2 className="remembering-gallery-title">Photos of Bob</h2>
        <div className="remembering-gallery-grid">
          {miscBobImages.map((img, idx) => (
            <img
              key={img}
              src={`/Assets/BobBelfi/miscBob/${encodeURIComponent(img)}`}
              alt={`Bob Belfi party ${idx + 1}`}
              className="remembering-gallery-img"
              onClick={() =>
                setSelectedImg(
                  `/Assets/BobBelfi/miscBob/${encodeURIComponent(img)}`,
                )
              }
              tabIndex={0}
              role="button"
              aria-label={`Enlarge image ${idx + 1}`}
            />
          ))}
        </div>
        {selectedImg && (
          <div className="lightbox" onClick={() => setSelectedImg(null)}>
            <img
              src={selectedImg}
              alt="Enlarged Bob Belfi pic"
              className="lightbox-img"
            />
          </div>
        )}
        <div className="remembering-signature">
          <p>— The Rolling Thunder Cycles Family</p>
        </div>
      </div>
    </div>
  );
}
